import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-cube", `bg--light-${_ctx.color} cube-width-${_ctx.width} cube-height-${_ctx.height} ${_ctx.rounded ? 'brs--large' : ''}`]),
    style: _normalizeStyle(`
    ${_ctx.left ? `left: ${_ctx.left};` : ''} ${_ctx.top ? `top: ${_ctx.top};` : ''} ${_ctx.right ? `right: ${_ctx.right};` : ''} ${_ctx.bottom ? `bottom: ${_ctx.bottom};` : ''}
    `)
  }, null, 6))
}